import $ from 'jquery';

export const accordion = () => {
    const accordionItem = $('.accordion__item');
    const accordionButton = $('.accordion__head');
    const accordionContent = $('.accordion__body');
    const activeClass = 'accordion__item--active';

    $(accordionButton).on('click', function() {
        if (!$(this).parent(accordionItem).hasClass(activeClass)) {
            $(this).parent(accordionItem).siblings(accordionItem).removeClass(activeClass);
            $(this).parent(accordionItem).siblings(accordionItem).find(accordionContent).slideUp('fast');
        }

        $(this).parent(accordionItem).toggleClass(activeClass);
        $(this).next(accordionContent).slideToggle('fast');
    });

    $(accordionItem).each(function(index, item) {
        if ($(item).hasClass(activeClass)) {
            $(item).children(accordionContent).slideDown('fast');
        }
    });

    $(window).on('resize', function(){
        if ($(window).width() > 1239) {
            $(accordionItem).each(function(index, item) {
                if ($(item).hasClass('navigation__item')) {
                    $(item).find(accordionButton).unbind('click');
                    $(item).find(accordionContent).css('display', 'block');
                }
            });
        }
    }).resize();
};
